import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  && .MuiFormLabel-root {
    font-size: 12px;
  }
`;

export const FormGroupContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "100%"};
    `}
`;
